@for (toast of feedbackService.toasts(); track toast.textOrTpl) {
  <ngb-toast [class]="toast.classname" [autohide]="true" (hidden)="feedbackService.remove(toast)">
    @if (typeof toast.textOrTpl !== 'string') {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      {{ toast.textOrTpl }}
    }
  </ngb-toast>
}
